import dayjs from "dayjs";
import "dayjs/locale/fr";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import style from "./style.module.scss";

interface TimesheetDateNavigationProps {
  startDate: string;
  selectedDate: string;
  onChange: (date: string) => void;
}

export const TimesheetDateNavigation = ({
  startDate,
  selectedDate,
  onChange,
}: TimesheetDateNavigationProps) => {
  const start = dayjs(startDate).locale("fr");

  const days = Array.from({ length: 8 }, (_, index) =>
    start.add(index, "day")
  );

  const scroll = (direction: "left" | "right") => {
    const container = document.querySelector(
      `.${style.date_navigation__days}`
    );

    if (!container) return;

    const dayWidth = container.clientWidth / 5;

    container.scrollBy({
      left: direction === "right" ? dayWidth : -dayWidth,
      behavior: "smooth",
    });
  };

  return (
    <div className={style.date_navigation__container}>
      <button
        type="button"
        className={style.date_navigation__arrow}
        onClick={() => scroll("left")}
      >
        <IoChevronBack />
      </button>

      <div className={style.date_navigation__days}>
        {days.map((date) => {
          const formattedDate = date.format("YYYY-MM-DD");

          const isActive =
            dayjs(selectedDate).format("YYYY-MM-DD") === formattedDate;

          return (
            <button
              key={formattedDate}
              type="button"
              className={`${style.date_navigation__dayItem} ${
                isActive ? style.date_navigation__active : ""
              }`}
              onClick={() => onChange(formattedDate)}
            >
              <span className={style.date_navigation__dayName}>
                {date.format("dddd")}
              </span>

              <span className={style.date_navigation__dayDate}>
                {date.format("D MMMM")}
              </span>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        className={style.date_navigation__arrow}
        onClick={() => scroll("right")}
      >
        <IoChevronForward />
      </button>
    </div>
  );
};